import React from 'react';
import { useMultiFactorAuthenticationContext } from './MultiFactorAuthenticationContext';
import { EnforcementStatus } from '../../../Infrastructure/API/MultiFactorAuthentication/list';
import { FormRenderProps } from 'react-final-form';
import useFeatureFlag from '../../../Infrastructure/FeatureFlags/useFeatureFlag';
import FeatureFlags from '../../../Infrastructure/FeatureFlags/FeatureFlags';
import MultiFactorAuthenticationLogin from './MultiFactorAuthenticationLogin';
import MultiFactorAuthenticationActivation from './MultiFactorAuthenticationActivation';

interface MultiFactorAuthenticationProps {
  formRenderProps: FormRenderProps;
  onGoBack: () => void;
  isRedirecting: boolean;
}

const MultiFactorAuthentication = ({
  formRenderProps,
  onGoBack: handleGoBackToLoginClick,
  isRedirecting,
}: MultiFactorAuthenticationProps) => {
  const hasMfaActivationDuringLoginEnabled = useFeatureFlag(FeatureFlags.EnableMfaActivationDuringLogin);
  const { authentications, enforcementStatus } = useMultiFactorAuthenticationContext();

  const shouldEnforce =
    enforcementStatus === EnforcementStatus.Enforced || enforcementStatus === EnforcementStatus.PendingEnforcement;
  const isActivationRequired = authentications.length === 0 && shouldEnforce;

  if (isActivationRequired && hasMfaActivationDuringLoginEnabled) {
    return <MultiFactorAuthenticationActivation onGoBackToLoginClick={handleGoBackToLoginClick} />;
  }

  return (
    <MultiFactorAuthenticationLogin
      formRenderProps={formRenderProps}
      onGoBackToLoginClick={handleGoBackToLoginClick}
      isRedirecting={isRedirecting}
    />
  );
};

export default MultiFactorAuthentication;
